import "./KendallHomeInspector.module.css";
import Header from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import CompanyIntroduction from "./sections/CompanyIntroduction";
import ServiceAreasListed from "./sections/ServiceAreasListed";
import ReadyToGrowYourRestaurant from "./sections/ReadyToGrowYourRestaurant";
import Footer from "@/reusable_sections/Footer";
export default function KendallHomeInspectorPage() {
  return <div>
      <Header />
      <HeroIntroduction />
      <CompanyIntroduction />
      <ServiceAreasListed />
      <ReadyToGrowYourRestaurant />
      <Footer />
    </div>;
}